import React from "react";
import { SearchGlobalContext } from "@/components/Modals/SearchGlobalModal/utils";
import ListEmptyPlaceholder from "@jd/focus-desktop-comps/lib/es/ListEmptyPlaceholder";
import DataList from "@/components/Modals/SearchGlobalModal/DataList";
import { SearchType } from "@/services/SearchService";
import { ListItemClickFn } from "@/components/Modals/SearchGlobalModal/Tabs";
import lodashTrim from "lodash/trim";
import { ListItemData } from "@jd/focus-desktop-comps/lib/es/ListItem";
import { analysisLog } from "@/utils/logAnalytics";

export default function TabPaneQunzu({ t, onClick }: { t: any; onClick?: ListItemClickFn }) {
  const { keyword } = React.useContext(SearchGlobalContext);
  if (!lodashTrim(keyword)) {
    return <ListEmptyPlaceholder placeholder={t("search.emptyPlQunzu")} />;
  }

  return (
    <DataList
      searchType={SearchType.Group}
      onClick={(data: ListItemData, index: number, pageSize: number) => {
        analysisLog("xtbg_home_search_1641454991771", "28");
        if (onClick) {
          onClick(SearchType.Group, { ...data, pageSortNo: index, pageSize });
        }
      }}
    />
  );
}
